"use client";

import { BlogPostArticle } from "@/components/blog/BlogPostArticle";
import { BlogPostBreadcrumbs } from "@/components/blog/BlogPostBreadcrumbs";
import { BlogPostSidebar } from "@/components/blog/BlogPostSidebar";
import LoadingOther from "@/components/index/fragments/LoadingOther";
import ModalWindows from "@/components/ModalWindows";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";
import { BlogPost } from "@/types";

type BlogPostPageClientProps = {
  initialPost: BlogPost | null;
  relatedPosts: Array<{ url: string; title: string }>;
  url: string;
  basePath?: string;
  author?: string;
  guideLabel?: string;
};

export default function BlogPostPageClient({
  initialPost,
  relatedPosts,
  url,
  basePath = "/pruvodce",
  author: providedAuthor,
  guideLabel,
}: BlogPostPageClientProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      home: "Domů",
      guide: "Průvodce realitami",
      changeMembership: "Změnit členství",
      upgradeMembership: "Zvýšit úroveň členství",
      createMembership: "Spravovat realitní portfolio",
    },
    en: {
      home: "Home",
      guide: "Real estate guide",
      changeMembership: "Change membership",
      upgradeMembership: "Upgrade membership",
      createMembership: "Create a watchdog",
    },
  }[language];
  const { blog, isLoggedIn, userInfoGlobal } = useAppContext();
  const { setSelectedItem } = useMenuItemsContext();

  const post = initialPost ?? blog?.items.find((item) => item.url === url);
  const author = providedAuthor ?? post?.author ?? blog?.author ?? "SOFTIQ";

  if (!post) return <LoadingOther />;

  return (
    <div className="relative min-h-screen max-w-screen-xl mx-auto mb-10 mt-10 px-4 sm:px-6 lg:px-8">
      <BlogPostBreadcrumbs
        homeLabel={copy.home}
        guideLabel={guideLabel ?? copy.guide}
        guideHref={basePath}
        title={post.title}
      />

      <div className="flex flex-col xl:flex-row gap-6">
        <BlogPostArticle post={post} />
        <BlogPostSidebar
          post={post}
          author={author}
          isLoggedIn={isLoggedIn}
          canUpgrade={
            isLoggedIn && userInfoGlobal?.membership !== "PROFESSIONAL"
          }
          upgradeMembershipLabel={copy.upgradeMembership}
          createWatchdogLabel={copy.createMembership}
          onUpgradeMembership={() => {
            setSelectedItem({
              name: copy.changeMembership,
              href: "",
              icon: null,
            });
          }}
          relatedPosts={relatedPosts}
          relatedPostsBasePath={basePath}
        />
      </div>

      <ModalWindows />
    </div>
  );
}
